export enum WebResourceConstants {
    SkuConsult = "SKU_CONSULT",
    MandatoryClientInfo = "MANDCLIENTINFO",
    MyOrders = "MYORDERS",
    MyOrdersMailEnabled = "MYORDERSMAIL",
    PartsEnabled = "PARTSMODULE",
    CanOrderAir = "AIR",
    PreciousModuleEnabled = "PRECIOUSMODULE",
    PriceModuleEnabled = "PRICEMODULE",
    Condensed = "CONDENSED",
    LoadData = "LOADDATA",
    NewCust = "NEW_CUST",
    ShowLindbergCollection = "LINDCOL",
    ShowSeasonalFocus = "SEASONSTYLES",
    FileMakerApps = "FILEMAKERAPPS"
}
